import { render } from "./cardsApp.vue?vue&type=template&id=56109ac8"
import script from "./cardsApp.vue?vue&type=script&lang=js"
export * from "./cardsApp.vue?vue&type=script&lang=js"

import "./cardsApp.vue?vue&type=style&index=0&id=56109ac8&lang=css"

import exportComponent from "/Users/zekarim/Documents/HEIG/roesti-quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__